<template>
  <div class="recommend">
    <div class="commission_box">
      <div class="commission_statistical">
        <div class="commission_oktotal">
          <p class="commission_okprice">{{ok_commission}}</p>
          <p class="commission_oklabel">可提现收入(元)</p>
        </div>

        <div class="commission_info flex_center">
          <div class="commission_totalprice">
            <p>累计收入(元)</p>
            <p>{{total_commission}}</p>
          </div>
          <div class="commission_finishprice">
            <p>已提现收入(元)</p>
            <p>{{finish_commission}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mb_5">
      <van-cell  @click="withdrawal()" title="提现" title-class="flex_center" is-link>
        <van-icon slot="icon" class=" iconfont icon-tixianchongzhi col_E97620"/>
      </van-cell>
      <van-cell to="/commission_qrcode" title="分享码" is-link>
        <van-icon slot="icon" class=" iconfont icon-iconfonterweima col_1EBF9D"/>
      </van-cell>
      <van-cell to="/commission_income" title="分红收入" is-link>
        <van-icon slot="icon" class=" iconfont icon-qian col_F8BF00"/>
      </van-cell>
      <van-cell to="/down" title="分享盟友" is-link>
        <van-icon slot="icon" class=" iconfont icon-tianchongxing-1 col_EA6953"/>
      </van-cell>
      <van-cell to="/withdrawal_log" title="提现明细" is-link>
        <van-icon slot="icon" class=" iconfont icon-dkw_zhangdan col_E97620"/>
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: "recommend",
  components: {},
  data() {
    return {
      member_commission:[],
      total_commission:0,
      ok_commission:0,
      finish_commission:0,
      member_withdrawal_condition:0,
    };
  },
  created() {
    this.get_commission();
  },
  methods: {
    get_commission(){
      this.axios({
        url: this.api.member.get_commission, 
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member_commission = res.member_commission;
          this.total_commission = res.total_commission;
          this.ok_commission = res.ok_commission;
          this.finish_commission = res.finish_commission;
          this.member_withdrawal_condition  =res.member_withdrawal_condition;
        }
      });
    },
    withdrawal(){
        if(this.ok_commission>0){
          if(this.member_withdrawal_condition>this.ok_commission){
             this.$toast({
              message:"可提现收入满"+this.member_withdrawal_condition+"才能提现",
              duration:1500,
            });
            return;
          }
           this.$router.push({path:"/withdrawal",query:{}});
        }else{
           this.$toast("提现金额不足");
        }
      
    }
  }
};
</script>
<style scoped>
.commission_statistical {
  background-color: #45b9bc;
  color: white;
}
.commission_oktotal {
  text-align: center;
  padding: 2.5rem 0 1.5rem 0;
}
.commission_okprice {
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: bold;
}
.commission_oklabel {
  font-size: 0.6rem;
  color: #ffffff;
  margin-top: 0.1rem;
}
.commission_info {
  background-color: rgba(27, 27, 27, 0.2);
  text-align: center;
}
.commission_totalprice {
  border-right: 1px solid #ffffff;
}
.commission_totalprice,
.commission_finishprice {
  width: 50%;
  color: #ffffff;
  font-size: 0.6rem;
  margin: 0.35rem 0;
}
.commission_totalprice p,
.commission_finishprice p {
  padding: 0.1rem 0;
}
.recommend_nav span {
  font-size: 0.75rem;
  color: #464646;
}
.recommend_navli {
  border-bottom: 1px solid #eee;
}
.van-cell .iconfont{
  margin-right: .5rem;
  font-size: 1rem;
  width: 1rem;
  height: 1.2rem;
  line-height: 1.2rem;
}

</style>



// WEBPACK FOOTER //
// src/views/center/recommend/recommend.vue